module.exports = __webpack_public_path__ + "static/img/weather_007.ed8e7a03.svg";